import { ref } from 'vue'

import { type RequestReturn } from '@shopify/shopify-api'

import { type ShopifyGraphQLResponse } from '@/types/shopify'

import { type Product, type ProductRecommendations, type ProductRecommendation } from '@/types'

export const useProductRecommendations = (productDetail: Product) => {
  const product = ref<undefined | Product>(productDetail)

  const productRecommendations = ref<ProductRecommendation[]>([])

  const fetchProductRecommendations = async (id: string) => {
    const { data } = await useFetch<RequestReturn<ShopifyGraphQLResponse<ProductRecommendations>>>(
      `/api/products/recommendations?id="${id}"`, 
      { 
        key: `${id}-recommendations` 
      }
    )

    if (!data.value) return

    productRecommendations.value = data.value.body.data.productRecommendations
  }

  watch(product, () => {
    if (!product.value) return
    fetchProductRecommendations(product.value.id)
  }, {
    immediate: true
  })

  return {
    productRecommendations
  }
}